/* Fanned poster strip — the mechanics are d360's PortfolioGallery:
   overlapping cells, hard right-edge shadow, descending z-index so the
   leftmost sits on top, and a gradient backdrop for label legibility. */

.base {
  position: relative;
  display: block;
  height: 100%;
  width: 100%;
  overflow: hidden;
  background: var(--bg-surface);
}

.strip {
  display: flex;
  height: 100%;
  /* Contains the stacking context so cell z-index can't escape the tile. */
  isolation: isolate;
}

.cell {
  position: relative;
  flex: 1 1 0;
  min-width: 0;
  height: 100%;
  /* The shadow falls to the RIGHT, so each poster casts onto its neighbour —
     that shadow is what reads as a fan rather than a plain filmstrip. */
  box-shadow: 8px 0 10px 0 rgb(0 0 0 / 0.55);
}

/* Descending z-index: first poster on top, each subsequent one behind. */
.cell:nth-child(1) { z-index: 6; }
.cell:nth-child(2) { z-index: 5; }
.cell:nth-child(3) { z-index: 4; }
.cell:nth-child(4) { z-index: 3; }
.cell:nth-child(5) { z-index: 2; }
.cell:nth-child(6) { z-index: 1; }

/* A single subject gets the full frame rather than a lone narrow slice. */
.cell:only-child {
  flex-basis: 100%;
  box-shadow: none;
}

.img {
  position: absolute;
  inset: 0;
  height: 100%;
  width: 100%;
  object-fit: cover;
  object-position: center top;
  color: transparent;
}

/* Platform logos are transparent PNGs with their own padding — contain them
   on a neutral ground instead of cropping the mark. */
.base[data-kind='platforms'] .cell {
  background: var(--bg-elevated);
  box-shadow: 1px 0 0 0 var(--bg-base);
}

.base[data-kind='platforms'] .img {
  object-fit: contain;
  padding: var(--space-3);
}

.missing {
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, var(--bg-elevated), var(--bg-card));
}

/* Two gradients: a left-to-right wash for the tag, and a top band so the
   label never fights bright artwork. */
.backdrop {
  position: absolute;
  inset: 0;
  z-index: 7;
  pointer-events: none;
  background:
    linear-gradient(100deg, rgb(0 0 0 / 0.78), transparent 62%),
    linear-gradient(180deg, rgb(0 0 0 / 0.45), transparent 26%);
}

.tag {
  position: absolute;
  top: var(--space-3);
  left: var(--space-3);
  z-index: 8;
  font-family: var(--font-display);
  font-size: var(--text-xs);
  font-weight: var(--weight-bold);
  letter-spacing: var(--tracking-wide);
  text-transform: uppercase;
  color: var(--text-primary);
  text-shadow: 0 1px 3px rgb(0 0 0 / 0.6);
}
